import React, { useState, useEffect } from 'react';
import { Listing } from '../../types';
import { ListingCard } from '../../components/listing/ListingCard';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

export const BuyerWishlist: React.FC = () => {
  const [wishlist, setWishlist] = useState<Listing[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchWishlist = async () => {
    try {
      const res = await fetch('/api/buyer/wishlist');
      if (res.ok) {
        const data = await res.json();
        if (data.success) setWishlist(data.wishlist || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  const handleRemove = async (id: string) => {
    try {
      await fetch(`/api/listings/${id}/wishlist`, { method: 'POST' });
      setWishlist(prev => prev.filter(item => item.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="border-b border-brand-lightBorder dark:border-brand-darkBorder pb-6">
        <h1 className="text-3xl font-black text-brand-lightText dark:text-brand-darkText flex items-center gap-3">
          <Heart className="w-7 h-7 text-rose-500 fill-current" />
          <span>My Saved Wishlist</span>
        </h1>
        <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText mt-1">
          Keep track of desired gaming items and price changes
        </p>
      </div>

      {wishlist.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {wishlist.map((item) => (
            <ListingCard
              key={item.id}
              listing={item}
              isWishlisted={true}
              onWishlistToggle={handleRemove}
            />
          ))}
        </div>
      ) : (
        <div className="p-16 rounded-3xl bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder text-center space-y-3">
          <Heart className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto" />
          <h3 className="font-bold text-base text-brand-lightText dark:text-brand-darkText">Your wishlist is empty</h3>
          <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText">Click the heart icon on any listing card to save it for later.</p>
          <Link
            to="/browse"
            className="inline-block mt-2 px-6 py-2.5 rounded-xl font-bold text-xs text-white bg-brand-blue"
          >
            Discover Listings
          </Link>
        </div>
      )}
    </div>
  );
};
